module.exports = __webpack_public_path__ + "img/complete_content.96e4d63d.png";